import "../../../pages/Web/Web.scss";

const TitleAndImage = ({ image, title }) => {
  //   useEffect(() => {
  //     console.log(files);
  //   }, [files]);

  return (
    <div className="WebHomePage">
      <p className="WebHomePage__title">
        <span className="WebHomePage__title__bold">Título:</span> {title}
      </p>
      <img
        className="image-and-video-styles"
        src={image}
        alt="Imagen principal de la home page"
      />
    </div>
  );
};

export default TitleAndImage;
